/**
 * @class
 * @description This class reports current pluguin status to the DB
 * @exports StatsReportingBusinessObject
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import StatsBean from '../Beans/StatsBean';
export default class StatsReportingBusinessObject {
    constructor(loader) {
        this.started = false;
        this.stopped = false;
        this.loader = loader;
    }
    start(host, token, accountCode, profileName, resource) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.started)
                return;
            this.started = true;
            this.report(host, token, accountCode, profileName, resource);
        });
    }
    report(host, token, accountCode, profileName, resource) {
        try {
            if (!this.stopped) {
                let statsMap = new Map();
                this.loader.CDNLoader.getCdnList().forEach((cdn) => {
                    let statsBean = new StatsBean(cdn.name, cdn.provider, cdn.downloadedBytes, cdn.downloadedChunks, cdn.totalFail, cdn.downloadMillis, cdn.highestSegmentBandwidth, cdn.lowestSegmentBandwidth, cdn.bannedCount, cdn.unBannedCount, cdn.avgPingTime, cdn.lowestPingTime, cdn.highestPingTime, cdn.banned, cdn.active);
                    statsMap.set(cdn.name, statsBean);
                });
                if (this.loader.P2PLoader.isEnabled) {
                    let p2pStats = this.loader.P2PLoader.getStats();
                    let statsBean = new StatsBean("P2P", "P2P", p2pStats.downloadedBytes || 0, p2pStats.downloadedSegments || 0, 0, p2pStats.downloadMillis, 0, 0, 0, 0, 0, 0, 0, false, true);
                    statsMap.set("P2P", statsBean);
                }
                let jsonObject = {};
                statsMap.forEach((value, key) => {
                    jsonObject[key] = value;
                });
                if (statsMap.size > 0) {
                    this.reportRequest(host, token, accountCode, profileName, resource, JSON.stringify(jsonObject));
                }
            }
        }
        catch (e) { }
        setTimeout(function () {
            StatsReportingBusinessObject.getInstance().report(host, token, accountCode, profileName, resource);
        }, 10000);
    }
    reportRequest(host, token, accountCode, profileName, resource, detail) {
        if (detail == "" || detail == "{}") {
            return;
        }
        const paramsObject = {
            token: token,
            accountCode: accountCode,
            profileName: profileName,
            data: detail
        };
        let target = new URL("https://" + host + "/cdn");
        target.search = new URLSearchParams(paramsObject).toString();
        let request = new XMLHttpRequest();
        request.open("GET", target.toString());
        request.send();
    }
    static getInstance(loader) {
        if (this._instance == undefined && loader != undefined) {
            this._instance = new StatsReportingBusinessObject(loader);
        }
        return this._instance;
    }
}
